// extracted by mini-css-extract-plugin
export default {"addButton":"Zpm8p4YQsUabS6cjRUMI","counterWrapper":"dVRmF2FWyMfmW7BZOSRH","changeButton":"eyPgSiYYxRLn77BmIdhb","counter":"b1zQO4DGsMySP8GqvBJs"};